export default __webpack_public_path__ + "static/02_Ox-8f9b00dd73195c7c185164a3a24babd2.png";